import { render, staticRenderFns } from "./RgInternationalAccountInfo.vue?vue&type=template&id=6d267a63&"
import script from "./RgInternationalAccountInfo.vue?vue&type=script&lang=js&"
export * from "./RgInternationalAccountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports